// ARCA-159 — per-match power-up usage caps (client-side mirror).
//
// Source of truth: apps/backend/src/match/powerups/registry.ts
// (`MAX_USES_PER_MATCH`, DEC-024 / GDD §5.8). The 1/match vs 2/match split is
// a spec invariant, NOT a balance tunable — keep this mirror byte-for-byte
// with the backend table; drift would mislabel the PowerupTray indicator.
//   Tongue-Tie / Knight's Vow / Anagram Sigil — 2/match
//   Scrivener's Quill / Lexical Mulligan / Castle Keep / The Vanishing /
//     Whisperer's Promise                     — 1/match each
//
// The server is authoritative on enforcement (DEC-021); this mirror exists
// ONLY so the PowerupTray can render a remaining-use indicator
// (`max - your_powerups_used[name]`) without a wire round-trip. No I/O.

import type { PowerUpName } from '../PlayerViewSchema'

// `Readonly<Record<PowerUpName, 1 | 2>>` (NOT `as const`) so a runtime
// `PowerUpName` variable indexes structurally — matches the backend shape.
export const MAX_USES_PER_MATCH: Readonly<Record<PowerUpName, 1 | 2>> =
  Object.freeze({
    scriveners_quill: 1,
    tongue_tie: 2,
    lexical_mulligan: 1,
    knights_vow: 2,
    castle_keep: 1,
    anagram_sigil: 2,
    the_vanishing: 1,
    whisperers_promise: 1,
  })

/** Per-match use cap for a power-up (1 for one-shots, 2 for the multi-use trio). */
export function maxUsesFor(name: PowerUpName): number {
  return MAX_USES_PER_MATCH[name]
}
